import script from "./StepIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./StepIndicator.vue?vue&type=script&setup=true&lang=js"

import "./StepIndicator.vue?vue&type=style&index=0&id=4612f9b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4612f9b4"]])

export default __exports__